// register component(s) with react habitat
import codeSplit from 'scripts/higher-order-components/codeSplit';

export default {
	RegistrationForm: codeSplit( {
		loadComponent: () =>
			import(
				/* webpackChunkName: "RegistrationForm" */
				'./index'
			),
	} ),
};
